export const modelDiscoveryTextV109 = (language) => {
  const zh = String(language || 'zh').startsWith('zh');
  return zh
    ? {
        explore: '探索其他模型',
        back: '返回可用模型',
        title: '其他模型',
        description:
          '以下模型当前未向您的账号开放，暂不可调用。如需使用，欢迎联系平台管理员，商讨模型开通、使用需求及定制合作方案。',
        unavailable: '当前账号未开通',
        contact: '联系平台管理员',
        inquiry: '咨询此模型',
        cardDescription: '如需使用，请联系平台管理员商讨开通。',
        loading: '正在加载其他模型...',
        failed: '其他模型加载失败，请稍后重试。',
        empty: '暂无其他可展示模型。如有特定模型需求，欢迎联系平台管理员。',
        contactFallback: '请通过您已有的业务对接渠道联系平台管理员。',
        contactNote: '模型开通及合作方案需经平台管理员确认。',
        copyInquiry: '复制咨询内容',
        copied: '咨询内容已复制',
        copyFailed: '复制失败，请手动选择咨询内容。',
        inquiryText: (model) =>
          `您好，我希望了解${
            model ? ` ${model} ` : '其他模型'
          }的开通及合作方案，请协助确认使用条件、价格和接入安排。`,
        settingsTitle: '其他模型展示与合作咨询',
        modelsLabel: '对外展示模型 ID（每行一个，留空不展示）',
        contactLabel: '合作联系方式（向客户公开，留空使用业务对接提示）',
        save: '保存展示与联系方式',
        saved: '展示与联系方式已保存',
      }
    : {
        explore: 'Explore other models',
        back: 'Back to available models',
        title: 'Other models',
        description:
          'These models are not enabled for your account and cannot currently be called. Contact the platform administrator to discuss access, usage requirements and a tailored cooperation plan.',
        unavailable: 'Not enabled for your account',
        contact: 'Contact platform administrator',
        inquiry: 'Ask about this model',
        cardDescription:
          'Contact the platform administrator to discuss access.',
        loading: 'Loading other models...',
        failed: 'Other models could not be loaded. Please try again.',
        empty:
          'No other models to display. Contact the platform administrator about specific model requirements.',
        contactFallback:
          'Please contact the platform administrator through your existing business contact.',
        contactNote:
          'Model access and cooperation terms require confirmation by the platform administrator.',
        copyInquiry: 'Copy inquiry',
        copied: 'Inquiry copied',
        copyFailed: 'Copy failed. Please select the inquiry text manually.',
        inquiryText: (model) =>
          `Hello, I would like to discuss access and cooperation for ${
            model || 'additional models'
          }. Please confirm usage requirements, pricing and integration arrangements.`,
        settingsTitle: 'Other models and cooperation',
        modelsLabel: 'Public model IDs (one per line; leave empty to hide all)',
        contactLabel:
          'Business contact (public to customers; leave empty for existing-contact guidance)',
        save: 'Save models and contact',
        saved: 'Models and contact saved',
      };
};
